import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF", width = "8", height = "13" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11 1L2 8.73077L11 16" stroke="#D7D7D7" strokeWidth="2" />
    </svg>
  );
};

export default memo(Icon);
